<op-sidemenu
  [items]="menuItems$ | async"
  data-qa-selector="op-sidemenu"
></op-sidemenu>
